
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import axios from '../../API/axios';

const Checkbtn = () => {
    const sessionId = localStorage.getItem('sessionId')
    const [showEditProfile, setShowEditProfile] = useState(false);
    const checkProfile = async () => {
        const data = {
            sessionId: sessionId,
        };
        try {
            const response = await
                axios
                    .post('/CandidateData/Check', data);

            const res = response.data.responseData;
            setShowEditProfile(!data.responseData);
            console.log("data ", res);

        } catch (error) {
            console.error('Error fetching profile status:', error);
        }
    };

    useEffect(() => {
        checkProfile();
    }, []);

    return (
        <>
            <div className="edit-profile-btn text-center">
                <Button className="f-13">
                    <Link to="/Candidate">
                        {showEditProfile ? 'Edit Profile' : 'Add Profile'}
                    </Link>
                </Button>
            </div>
        </>
    );
};

export default Checkbtn;
